/**
 * Generates a query string from the given URLSearchParams object.
 * @param searchParams - The URLSearchParams object containing the query parameters.
 * @returns The generated query string.
 */
export const generateQueryParams = (searchParams: URLSearchParams) => {
  let result = '';
  for (const param of searchParams) {
    result += (result ? '&' : '?') + param[0] + '=' + param[1];
  }
  return result;
};

/**
 * Appends query parameters from a query string to an existing URL.
 * @param url - The base URL to append parameters to.
 * @param queryString - The query string containing parameters to append.
 * @returns The URL with appended query parameters.
 */
export function appendQueryParams(url: string, queryString: string): string {
  if (!queryString) return url;

  const urlObj = new URL(url, window.location.origin);
  const newParams = new URLSearchParams(queryString);

  newParams.forEach((value, key) => {
    urlObj.searchParams.append(key, value);
  });

  return urlObj.toString();
}
